<app-icon-badge class="flex-0" icon="fa-solid fa-users"></app-icon-badge>

<app-title-description
	class="flex-1"
	[title]="group.name"
	[description]="
		('groups.label.singular' | translate) +
		(group.description ? ' • ' + group.description : '')
	"
></app-title-description>
